module.exports = __webpack_public_path__ + "img/header-pc-1.9f42847e.png";